import React from 'react';
import PropTypes from 'prop-types';
/* styles */
import './iframe.scss';

export default class Iframe extends React.PureComponent {
  render() {
    return (
      <div className="glu-iframe-container">
        <iframe src={this.props.source} title="iframe" />
      </div>
    );
  }
}

Iframe.propTypes = {
  source: PropTypes.string,
};

Iframe.defaultProps = {
  source: undefined,
};
